import { useRouter } from 'next/router';
import { createPortal } from 'react-dom';
import {
  HeaderPopupContainer,
  HeaderPopupMenu,
  HeaderPopupMenuIcon,
  HeaderPopupBackdrop,
  HeaderPopupDropdown,
  HeaderPopupDropdownLink,
} from './header-popup.styles';
import { useEffect, useRef, useState } from 'react';

import { LIBUM_PORTAL } from 'shared/constants/globals';

const PRODUCT_LINKS = [
  { name: 'PowerOn Pipelines', href: '/poweron-pipelines' },
  { name: 'PowerOn Pro', href: '/poweron-pro' },
  { name: 'NexumAPI', href: '/nexum' },
  { name: 'Glaci', href: '/glaci' },
];

export default function HeaderPopup({}) {
  const ref = useRef<HTMLDivElement | null>(null);
  const router = useRouter();
  const [isActive, setIsActive] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (isActive) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isActive]);

  const togglePopup = (): void => {
    setIsActive(!isActive);
  };

  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, href: string) => {
    e.preventDefault();
    setIsActive(false);
    router.push(href);
  };

  const isCurrentPage = (href: string): boolean => {
    return router.pathname === href || router.pathname.startsWith(href + '/');
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsActive(false);
  };

  const dropdown = (
    <>
      <HeaderPopupBackdrop $isVisible={isActive} onClick={handleBackdropClick} />
      <HeaderPopupDropdown $isVisible={isActive}>
        {PRODUCT_LINKS.map((product) => (
          <HeaderPopupDropdownLink
            key={product.href}
            href={product.href}
            onClick={(e) => handleNavigation(e, product.href)}
            className={isCurrentPage(product.href) ? 'active' : ''}
          >
            {product.name}
          </HeaderPopupDropdownLink>
        ))}
        <HeaderPopupDropdownLink
          href={LIBUM_PORTAL}
          target="_blank"
          className="sign-in"
          onClick={() => setIsActive(false)}
        >
          Sign in
        </HeaderPopupDropdownLink>
      </HeaderPopupDropdown>
    </>
  );

  return (
    <>
      <HeaderPopupContainer ref={ref}>
        <HeaderPopupMenu onClick={togglePopup} aria-label="Libum mobile menu" className={isActive ? 'active' : ''}>
          <HeaderPopupMenuIcon className={isActive ? 'active' : ''}>
            <span />
            <span />
            <span />
          </HeaderPopupMenuIcon>
        </HeaderPopupMenu>
      </HeaderPopupContainer>
      {mounted && createPortal(dropdown, document.body)}
    </>
  );
}
